export default "__VITE_ASSET__ngHVbDDh__"